import React from "react";

const Footer = () => {
  return (
    <div className="mt-44 mb-2">
      <h2 className="text-gray-300 text-center">
        © Copyright 2025. Made by GJ
      </h2>
    </div>
  );
};

export default Footer;
